// components/Layout/AuthenticatedLayout.jsx
import React, { useState, useEffect } from "react";
import { Outlet } from "react-router-dom";
import Navbar from "../Navbar";
import Sidebar from "../Sidebar";
import { useAuth } from "../../context/AuthContext";

const AuthenticatedLayout = () => {
  const { user, isAuthenticated, logout } = useAuth();
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkScreenSize = () => {
      const mobile = window.innerWidth < 1024;
      setIsMobile(mobile);

      if (!mobile) {
        setIsSidebarOpen(true); // Always open on desktop
      } else {
        setIsSidebarOpen(false); // Closed by default on mobile
      }
    };

    checkScreenSize();
    window.addEventListener("resize", checkScreenSize);

    return () => window.removeEventListener("resize", checkScreenSize);
  }, []);

  const handleSidebarToggle = () => {
    if (isMobile) {
      setIsSidebarOpen(!isSidebarOpen);
    }
  };

  const handleSidebarClose = () => {
    if (isMobile) {
      setIsSidebarOpen(false);
    }
  };

  return (
    <div className="min-h-screen bg-background">
      {/* Fixed Navbar at the top */}
      <Navbar
        user={user}
        isAuthenticated={isAuthenticated}
        onSidebarToggle={handleSidebarToggle}
        onLogout={logout}
        isMobile={isMobile}
      />

      {/* Sidebar */}
      <Sidebar
        isOpen={isSidebarOpen}
        onClose={handleSidebarClose}
        user={user}
        isMobile={isMobile}
      />

      {/* Main Content Area - FIXED MARGINS */}
      <main
        className={`min-h-screen transition-all duration-300 ${
          !isMobile && isSidebarOpen
            ? "ml-64" // Add left margin when sidebar is open on desktop
            : "ml-0" // No margin on mobile or when sidebar is closed
        }`}
      >
        <div>
          <Outlet />
        </div>
      </main>
    </div>
  );
};

export default AuthenticatedLayout;
